"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpan = exports.StyledCheckBoxComponent = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _framerMotion = require("framer-motion");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledSpan = exports.StyledSpan = (0, _styledComponents.default)(_framerMotion.m.span)`
	${({
  width,
  height,
  background,
  borderRadius = '8px',
  borderColor,
  hoverBorderColor,
  disabled,
  checkBoxDimensions,
  defaultBorderWidth = 2,
  hoverBorderWidth = 2,
  activeBorderWidth = 2,
  borderStyle = 'solid'
}) => {
  return (0, _styledComponents.css)`
			width: ${checkBoxDimensions};
			height: ${checkBoxDimensions};
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: ${background};
			border-radius: ${borderRadius};
			border: ${defaultBorderWidth}px ${borderStyle} ${borderColor};
			:hover {
				${disabled ? '' : `border: ${defaultBorderWidth}px ${borderStyle} ${hoverBorderColor}`};
			}
		`;
}}
`;
const StyledCheckBoxComponent = exports.StyledCheckBoxComponent = _styledComponents.default.div`
	${({
  disabled,
  padding,
  margin
}) => {
  return `${disabled ? '' : `cursor: pointer;
			padding:${padding};
			margin:${margin};
			`}`;
}}
`;